import IndexPage, { getServerSideProps } from 'pages/[lang]';

export default IndexPage;

export { getServerSideProps };
